import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchDashboard, clearDashboard } from '@store/slices/dashboardSlice';

export const DashboardInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const dashboard = useAppSelector((state) => state.dashboard.dashboard);
  const isLoadingDashboard = useAppSelector(
    (state) => state.dashboard.isLoading
  );

  useEffect(() => {
    const username = user?.username;

    // Clear dashboard when user logs out
    if (!username) {
      dispatch(clearDashboard());
      return;
    }

    // Fetch dashboard when user is available and dashboard is not already loaded
    if (!dashboard && !isLoadingDashboard) {
      dispatch(fetchDashboard(username));
    }
  }, [user?.username, dashboard, isLoadingDashboard, dispatch]);

  return null;
};
